const COUNT_SELECTOR = ".hero--home-split [data-count-up]";
const DEFAULT_COUNT_DELAY = 0;
const COUNT_DURATION = 1100;

function splitCountText(value) {
	const match = String(value).trim().match(/^(.*?)([\d,]+(?:\.\d+)?)(.*)$/);

	if (!match) {
		return null;
	}

	const [, prefix, numberText, suffix] = match;
	const target = Number.parseFloat(numberText.replaceAll(",", ""));

	if (!Number.isFinite(target)) {
		return null;
	}

	return {
		decimals: numberText.includes(".") ? numberText.split(".")[1].length : 0,
		prefix,
		suffix,
		target,
		usesGrouping: numberText.includes(","),
	};
}

function formatCount(value, parts) {
	const rounded = parts.decimals
		? value.toFixed(parts.decimals)
		: String(Math.round(value));
	const formatted = parts.usesGrouping
		? Number(rounded).toLocaleString("en-GB", {
				maximumFractionDigits: parts.decimals,
				minimumFractionDigits: parts.decimals,
			})
		: rounded;

	return `${parts.prefix}${formatted}${parts.suffix}`;
}

function animateCount(element, parts) {
	const start = window.performance.now();

	function tick(now) {
		const progress = Math.min((now - start) / COUNT_DURATION, 1);
		const eased = 1 - (1 - progress) ** 3;

		element.textContent = formatCount(parts.target * eased, parts);

		if (progress < 1) {
			window.requestAnimationFrame(tick);
			return;
		}

		element.textContent = element.dataset.countUpTarget;
	}

	window.requestAnimationFrame(tick);
}

function getCountDelay(element) {
	const delay = Number.parseInt(element.dataset.countDelay, 10);

	return Number.isFinite(delay) ? delay : DEFAULT_COUNT_DELAY;
}

export function initHomeHero() {
	const prefersReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)",
	).matches;

	for (const element of document.querySelectorAll(COUNT_SELECTOR)) {
		const targetText = element.textContent.trim();
		const parts = splitCountText(targetText);

		if (!parts) {
			continue;
		}

		element.dataset.countUpTarget = targetText;

		if (prefersReducedMotion) {
			element.textContent = targetText;
			continue;
		}

		element.textContent = formatCount(0, parts);
		window.setTimeout(() => animateCount(element, parts), getCountDelay(element));
	}
}
